module.exports = __webpack_public_path__ + "media/images/emblems/Treyvaux-coat_of_arms-df75a40a33f1ba0d6a1cffa6ba919f62.svg";